export const useStorage = () => {
  const emailAuth = localStorage.getItem('emailAuth')
  const tokenEmail = localStorage.getItem('tokenAuth')
  const getDelegacao = localStorage.getItem('delegacao')
  const getIdTokenParsed = JSON.parse(localStorage.getItem('idTokenParsed'))
  const getKeycloackToken = localStorage.getItem('keycloakToken')
  const getUserInfo = JSON.parse(localStorage.getItem('userInfo'))
  const getLogout = localStorage.getItem('logout')

  const setDelegacao = (delegacao) => localStorage.setItem('delegacao', delegacao)
  const deleteDelegacao = () => localStorage.removeItem('delegacao')
  const setIdTokenParsed = (idTokenParsed) => localStorage.setItem('idTokenParsed', JSON.stringify(idTokenParsed))
  const deleteIdTokenParsed = () => localStorage.removeItem('idTokenParsed')
  const setKeycloakToken = (keycloakToken) => localStorage.setItem('keycloakToken', keycloakToken)
  const deleteKeycloakToken = () => localStorage.removeItem('keycloakToken')
  const setUserInfo = (userInfo) => localStorage.setItem('userInfo', JSON.stringify(userInfo))
  const deleteUserInfo = () => localStorage.removeItem('userInfo')
  const deleteLogout = () => localStorage.removeItem('logout')
  const setConfiguracoes = (configuracoes) => localStorage.setItem('configuracoes', JSON.stringify(configuracoes))
  const setPoligonos = (poligono) => localStorage.setItem('poligonos', JSON.stringify(poligono))
  const getPoligonos = () => JSON.parse(localStorage.getItem('poligonos'))
  const deletePoligonos = () => localStorage.removeItem('poligonos')

  return {
    email: emailAuth,
    token: tokenEmail,
    setDelegacao,
    getDelegacao,
    deleteDelegacao,
    setIdTokenParsed,
    getIdTokenParsed,
    deleteIdTokenParsed,
    setKeycloakToken,
    getKeycloackToken,
    deleteKeycloakToken,
    setUserInfo,
    getUserInfo,
    deleteUserInfo,
    getLogout,
    deleteLogout,
    setConfiguracoes,
    setPoligonos,
    getPoligonos,
    deletePoligonos
  }
}
